export default __webpack_public_path__ + "static/media/employee.e75ae668.svg";